import { HiddenFieldsAlert } from "@/shared/value";
import { CompanyStructureSelect } from "@/modules/common/entities/company-structure/select";
import { PersonSelect } from "@/modules/common/entities/person/select";
import { SubmitButton, SubmitWrapper } from "@/shared/form/button";
import Dictionary from "@/shared/form/dictionary";
import Form from "@/shared/form/form";
import Input from "@/shared/form/input";
import { useTranslations } from "use-intl";
import { FieldsType } from "../model/types";
import { useBpmRoleAssignment } from "../model/use-bpm-role-assignment";
import { useBpmRole } from "../model/use-bpm-role";

export function BpmRolesForm({
  id,
  afterSubmit,
}: {
  id?: string;
  afterSubmit?: () => void;
}) {
  const t = useTranslations("Bpm");
  const { entity, hasHiddenFields } = useBpmRole({ id });
  const { save } = useBpmRoleAssignment({ afterSubmit });

  return (
    <>
      {hasHiddenFields && <HiddenFieldsAlert />}

      <Form
        layout="vertical"
        onFinish={save}
        initialValues={entity}
        disabled={hasHiddenFields}
      >
        <Form.Item<FieldsType> label={"Id"} name="id" hidden>
          <Input />
        </Form.Item>

        <Form.Item<FieldsType>
          label={t("Roles")}
          name="role"
          rules={[{ required: true }]}
        >
          <Dictionary dictionary="HrRole" />
        </Form.Item>

        <Form.Item<FieldsType>
          label={t("Department")}
          name="hierarchyElement"
          rules={[{ required: true }]}
        >
          <CompanyStructureSelect />
        </Form.Item>

        <Form.Item<FieldsType>
          label={t("Person")}
          name="person"
          rules={[{ required: true }]}
        >
          <PersonSelect />
        </Form.Item>

        <SubmitWrapper>
          <SubmitButton />
        </SubmitWrapper>
      </Form>
    </>
  );
}
